import React from "react";

const DEFAULT_ICON = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64' fill='%23fff'%3E%3Ccircle cx='32' cy='32' r='32' fill='%234f46e5'/%3E%3Cpath d='M20 26h24v14a4 4 0 0 1-4 4H24a4 4 0 0 1-4-4V26z' fill='%23fff'/%3E%3Crect x='28' y='18' width='8' height='10' rx='4' fill='%23fff'/%3E%3C/svg%3E";

const Chatbutton = ({ showchatbot, settings }) => {
  const chatbot_icon = settings?.avatar?.image_path
    ? `https://crmprod-api.greymatterz.com/${settings.avatar.image_path}`
    : DEFAULT_ICON;

  return (
    <div
      id="source-widget-container-right"
      style={{ position: "fixed", bottom: "24px", right: "20px", zIndex: 9999 }}
    >
      <div style={{ position: "relative", opacity: 1 }}>
        <button
          className="source-widget-button-1 source-tw-shadow-xl source-tw-fixed source-tw-outline-none source-tw-focus:outline-none source-tw-border-none source-tw-text-center source-tw-cursor-pointer hover:source-tw-scale-110 source-tw-transition-transform source-tw-duration-200"
          style={{
            // backgroundColor: "rgb(67, 183, 93)",
            bottom: "20px",
            right: "16px",
          }}
          onClick={showchatbot}
        >
          <img
            src={chatbot_icon}
            alt=""
            title=""
            onError={(e) => { e.currentTarget.src = DEFAULT_ICON; }}
            className="source-tw-object-cover source-tw-rounded-full"
            width="46"
            style={{ width: "66px", height: "66px" }}
          />
        </button>
      </div>
    </div>
  );
};

export default Chatbutton;
